import { useQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';
import { QUERY_KEYS } from '../constants/queryKeys';

export const useUnreadMessageCount = () => {
  const { data: unreadMessages } = useQuery(
    [QUERY_KEYS.UNREAD_MESSAGES],
    () => queryGet('/notifications/unread_messages'),
    {
      cacheTime: 0,
      staleTime: 0
    }
  );

  return unreadMessages?.unreadMessagesCount ?? 0;
};
